<template>
  <v-container>
    <v-form v-model="missingBlocks">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 sm4 md4>
            <v-text-field v-model="blockFloor" label="Floor" placeholder="Start Height" outline></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4>
            <h3>Blocks missed</h3>
            <p>{{this.missingBlocks}}</p>
            <v-btn @click="blockSubmit">submit</v-btn>
          </v-flex>
          <v-flex xs12 sm4 md4>
            <v-text-field v-model="blockCeiling" label="Ceiling" placeholder="End Height" outline></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-form v-model="missingTransactions">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 sm4 md4>
            <v-text-field v-model="transactionFloor" label="Floor" placeholder="Start Height" outline></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4>
            <h3>Transactions missed</h3>
            <p>{{this.missingTransactions}}</p>
            <v-btn @click="transactionSubmit">submit</v-btn>
          </v-flex>
          <v-flex xs12 sm4 md4>
            <v-text-field v-model="transactionCeiling" label="Ceiling" placeholder="End Height" outline></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-form v-model="missingContracts">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 sm4 md4>
            <v-text-field v-model="contractFloor" label="Floor" placeholder="Start Height" outline></v-text-field>
          </v-flex>
          <v-flex xs12 sm4 md4>
            <h3>Contracts missed</h3>
            <p>{{this.missingContracts}}</p>
            <v-btn @click="contractSubmit">submit</v-btn>
          </v-flex>
          <v-flex xs12 sm4 md4>
            <v-text-field v-model="contractCeiling" label="Ceiling" placeholder="End Height" outline></v-text-field>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
    <v-form v-model="accountBalance">
      <v-container>
        <v-layout row wrap>
          <v-flex xs12 sm12 md12>
            <v-text-field
              v-model="account"
              label="Account Address"
              placeholder="0x0e5f9a5bb620974910cdc385fc7bf5974da4b3a8"
              outline
            ></v-text-field>
            <v-btn @click="checkAccountBalance">Check Account Balance</v-btn>
          </v-flex>
          <v-flex
            xs12
            sm12
            md12
            v-if="Object.keys(this.accountBalance).length !== 0 && this.accountBalance.constructor === Object"
          >
            <v-container class="listContainer">
              <v-list-tile class="listData">
                <v-list-tile-title class="listCategory">Total Balance</v-list-tile-title>
                <v-list-tile-content>{{this.accountBalance.accountInfo.totalBalance}}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile class="listData">
                <v-list-tile-title class="listCategory">Available Balance</v-list-tile-title>
                <v-list-tile-content>{{this.accountBalance.accountInfo.availableBalance}}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile class="listData">
                <v-list-tile-title class="listCategory">Stake Sum</v-list-tile-title>
                <v-list-tile-content>{{this.accountBalance.accountInfo.stakeSum}}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile class="listData">
                <v-list-tile-title class="listCategory">Staking Reward</v-list-tile-title>
                <v-list-tile-content>{{this.accountBalance.accountInfo.stakingReward}}</v-list-tile-content>
              </v-list-tile>
              <v-list-tile class="listData">
                <v-list-tile-title class="listCategory">Pending Sum</v-list-tile-title>
                <v-list-tile-content>{{this.accountBalance.accountInfo.pendingSum}}</v-list-tile-content>
              </v-list-tile>
            </v-container>

            <b-table :data="this.accountBalance.stakeInfo.data" class="table">
              <template slot-scope="props">
                <b-table-column
                  field="validator_address"
                  label="Validator Address"
                >{{props.row.validator_address}}</b-table-column>
                <b-table-column
                  field="currentStake"
                  label="Current Stake"
                >{{props.row.currentStake}}</b-table-column>
                <b-table-column
                  field="award_ammount"
                  label="Award Amount"
                >{{props.row.award_amount}}</b-table-column>
                <b-table-column
                  field="pending_withdraw_amount"
                  label="Pending Withdraw Amount"
                >{{props.row.pending_withdraw_amount}}</b-table-column>
              </template>
            </b-table>

          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '../reusables/loader.vue';

export default {
  name: 'Developers',
  data() {
    return {
      blockFloor: '',
      blockCeiling: '',
      transactionFloor: '',
      transactionCeiling: '',
      contractFloor: '',
      contractCeiling: '',
      account: '',
    };
  },
  components: {
    Loader,
  },
  computed: {
    ...mapGetters([
      'missingBlocks',
      'missingTransactions',
      'missingContracts',
      'accountBalance',
    ]),
  },
  methods: {
    blockSubmit() {
      this.$store.dispatch('fetchMissingBlocks', {
        floor: this.blockFloor,
        ceiling: this.blockCeiling,
      });
    },
    blockClear() {
      this.$refs.form.reset();
    },
    transactionSubmit() {
      this.$store.dispatch('fetchMissingTransactions', {
        floor: this.transactionFloor,
        ceiling: this.transactionCeiling,
      });
    },
    contractSubmit() {
      this.$store.dispatch('fetchMissingContracts', {
        floor: this.contractFloor,
        ceiling: this.contractCeiling,
      });
    },
    checkAccountBalance() {
      this.$store.dispatch('checkAccountBalance', {
        address: this.account,
      });
    },
  },
};
</script>
